import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import PropTypes from "prop-types";
import React from "react";
import injectSheet from "react-jss";

const styles = theme => ({
  more: {
    cursor: "pointer",

    [`@media (max-width: ${theme.mediaQueryTresholds.L - 1}px)`]: {
      background: theme.main.colors.background,
      border: `1px solid ${theme.palette.secondary.main}`,
      borderRadius: `${theme.base.sizes.radius.small}px ${theme.base.sizes.radius.small}px 0 0`,
      borderBottom: "none",
      position: "absolute",
      left: "50%",
      top: -35,
      width: 60,
      height: 36,
      overflow: "hidden",
      zIndex: 1,
      transform: "translateX(-50%)",
      "&:focus": {
        outline: "none",
        "& svg": {
          fill: theme.palette.secondary.main
        }
      },
      "& svg": {
        transition: "all 0.5s",
        transform: "rotateZ(180deg)",
        fill: theme.main.colors.attention
      },
      "&.open": {
        "& svg": {
          transform: "rotateZ(0deg)"
        }
      }
    },
    [`@media (min-width: ${theme.mediaQueryTresholds.L}px)`]: {
      flexsShrink: 0,
      flexGrow: 0,
      width: 44,
      height: 38,
      background: "transparent",
      marginLeft: 10,
      borderRadius: theme.base.sizes.radius.small,
      border: `1px solid ${theme.base.colors.lines}`,
      display: "flex",
      transition: `background-color ${theme.time.duration.default}`,
      justifyContent: "center",
      alignItems: "center",
      padding: 0,
      zIndex: 1,

      "&:focus": {
        outline: "none"
      },
      "&:hover": {
        outline: "none"
      },
      "& svg": {
        transition: `all ${theme.time.duration.default}`
      },
      ".homepage &": {
        border: `1px solid transparent`,
        backgroundColor: "color(white alpha(-90%))",
        "&:hover": {
          backgroundColor: "color(white alpha(-60%))"
        }
      },
      ".open &": {
        backgroundColor: "color(white alpha(-10%))",
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,

        "&:hover": {
          backgroundColor: "color(white alpha(-10%))"
        },

        "& svg": {
          transform: "rotate(180deg)"
        }
      },

      ".fixed &": {
        border: `1px solid ${theme.base.colors.lines}`,
        height: 30
      }
    }
  }
});

const Expand = props => {
  const { onClick, expanded, classes } = props;

  return (
    <React.Fragment>
      <button
        className={`${classes.more} ${expanded ? "open" : ""}`}
        to="#"
        onClick={onClick}
        aria-label="expand"
      >
        <ExpandMoreIcon size={30} />
      </button>
    </React.Fragment>
  );
};

Expand.propTypes = {
  onClick: PropTypes.func,
  expanded: PropTypes.bool,
  classes: PropTypes.object.isRequired
};

export default injectSheet(styles)(Expand);



// WEBPACK FOOTER //
// ./src/components/Menu/Expand.js